import DispensaryInfoPage from 'src/dispensary/info';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';

DispensaryInfoPage.layout = MainDispensaryLayout;
export default DispensaryInfoPage;
